export interface ApplicationLanguage {
  isoCode: string;
  name: string;
  shortName: string;
}

export const LanguagesForDomain: Map<string, Array<ApplicationLanguage>> = new Map([
  ['CH', [
    { isoCode: 'de_CH', name: 'Deutsch - DE', shortName: 'DE' },
    { isoCode: 'fr_CH', name: 'Français - FR', shortName: 'FR' },
    { isoCode: 'it_CH', name: 'Italiano - IT', shortName: 'IT' }]],
  ['DE', [{ isoCode: 'de_DE', name: 'Deutsch - DE', shortName: 'DE' }]]
]);

export const DefaultLanguageForDomain: Map<string, string> = new Map([
  ['BIZ', 'de_DE'],
  ['CH', 'de_CH'],
  ['DE', 'de_DE'],
  ['TV', 'de_CH']
]);
